import { render, staticRenderFns } from "./InstantWinner.vue?vue&type=template&id=373288a2"
import script from "./InstantWinner.vue?vue&type=script&lang=js"
export * from "./InstantWinner.vue?vue&type=script&lang=js"
import style0 from "./InstantWinner.vue?vue&type=style&index=0&id=373288a2&prod&scss-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports